/* import __COLOCATED_TEMPLATE__ from './bulk-action-status.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';
import { BulkActionStatus as Status } from 'embercom/services/knowledge-hub-service';
import type IntlService from 'ember-intl/services/intl';
import { type SnackbarType } from 'embercom/services/snackbar';

interface Args {}

const IN_PROGRESS_STATUSES = [Status.InProgress, Status.DeleteInProgress];

export default class BulkActionStatus extends Component<Args> {
  @service declare appService: AppService;
  @service declare knowledgeHubService: KnowledgeHubService;
  @service declare intl: IntlService;

  constructor(owner: unknown, args: any) {
    super(owner, args);

    if (!IN_PROGRESS_STATUSES.includes(this.knowledgeHubService.bulkActionStatus)) {
      this.hideBanner();
    }
  }

  get showBanner(): boolean {
    return IN_PROGRESS_STATUSES.includes(this.knowledgeHubService.bulkActionStatus);
  }

  get showIcon() {
    return !IN_PROGRESS_STATUSES.includes(this.knowledgeHubService.bulkActionStatus);
  }

  get bannerType(): SnackbarType {
    switch (this.knowledgeHubService.bulkActionStatus) {
      case Status.InProgress:
      case Status.DeleteInProgress:
      default:
        return 'help';
    }
  }

  get bannerText() {
    switch (this.knowledgeHubService.bulkActionStatus) {
      case Status.InProgress:
        return this.intl.t('knowledge-hub.banners.bulk-action.in-progress');
      case Status.DeleteInProgress:
        return this.intl.t('knowledge-hub.banners.bulk-action.delete-in-progress');
      default:
        return '';
    }
  }

  @action hideBanner(): void {
    this.knowledgeHubService.bulkActionStatus = Status.None;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::Banners::BulkActionStatus': typeof BulkActionStatus;
    'knowledge-hub/banners/bulk-action-status': typeof BulkActionStatus;
  }
}
